import { render, staticRenderFns } from "./SosvActivityCalendar.vue?vue&type=template&id=85c28f56&"
import script from "./SosvActivityCalendar.vue?vue&type=script&lang=js&"
export * from "./SosvActivityCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SosvActivityCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports